import { sickLeave, sickLeavesReasons, upadetStatus } from "@/api/staff/askAssent";

export const actions = {       

  sickLeave({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
          sickLeave(params).then(res => {                
                commit("SET_LIST", res.data.result.data.sickLeaves);
                commit("UPDATE_PAGINATION", { key: 'total', value: res.data.result.data.pagination.total });
                resolve(res)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },
    upadetStatus({ commit }, id) {
      return new Promise((resolve, reject) => {
        upadetStatus(id).then(res => {                
              resolve(res)
          }).catch(err => {
              reject(err.response.data)
          })
      })
  },
    reasons({ commit }, params = {}) {
      return new Promise((resolve, reject) => {
        sickLeavesReasons()
              .then(res => {
                  commit("SET_REASON", res.data.result.data.reason);
                  // commit("UPDATE_PAGINATION", { key: 'total', value: res.data.result.data.pagination.total });
                  resolve(res);
              })
              .catch(err => {
                console.log(err);
                  reject(err);
              });
      });
    },
    empty({ commit }) {
        return new Promise((resolve, reject) => {
            commit("EMPTY_MODEL");
            resolve()
        })
    },
    updateSort({ commit }, sort) {
        commit("SET_SORT", sort)
    },

    updateFilter({ commit }, filter) {
        commit('SET_FILTER', JSON.parse(JSON.stringify(filter)))
    },

    updateColumn({ commit }, obj) {
        commit('UPDATE_COLUMN', obj)
    },
    updatePagination({ commit }, pagination) {
        commit('UPDATE_PAGINATION', pagination)
    },
    updatePaginationAttendance({ commit }, pagination) {
        commit('UPDATE_PAGINATION_ATTENDANCE', pagination)
    },
    refreshData({ commit }) {
        return new Promise((resolve, reject) => {
            commit("REFRESH");
            resolve()
        })
    },
};
